export default {"src":"/_next/static/media/ring.90c5ed51.svg","height":312,"width":312};